'use strict';
import angular from 'angular';
import ShippingErrorModalController from './shipping-error-modal/shipping-error-modal.controller';
import Address from '../../models/Address';
import ExistingAddressListController from "./existing-address-list.controller";
var ShippingOptionsController = /** @class */ (function () {
    /*@ngInject*/
    function ShippingOptionsController($scope, $rootScope, $mdDialog, $q, $state, Util, Auth, CartService, ModalPopupService, ShippingOptionsService, ShippingAddressListService, $timeout, $window, troveValidateaddressService, AddressService) {
        'ngInject';
        var _this = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$mdDialog = $mdDialog;
        this.$q = $q;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.Util = Util;
        this.Auth = Auth;
        this.CartService = CartService;
        this.ModalPopupService = ModalPopupService;
        this.ShippingOptionService = ShippingOptionsService;
        this.ShippingAddressListService = ShippingAddressListService;
        this.AddressService = AddressService;
        this.troveValidateaddressService = troveValidateaddressService;
        this.loggedInUser = {};
        this.addressInfo = {};
        this.newShippingAddress = {};
        this.theShippingAddress = {};
        this.ShippingAddressChecked = {};
        this.shippingMethod = {};
        this.isNewAddress = false;
        this.isDefault = false;
        this.isShippingOptionSelected = false;
        this.displayAddressSpinner = false;
        this.displayInfoCard = false;
        this.displayShippingOption = false;
        this.disableDefaultCheckbox = false;
        this.isHeatSensitiveItemInCart = false;
        this.addressId = '';
        this.addressKey = 0;
        this.sourceValidateAddress = 0;
        this.handleSubscription = {};
        $rootScope.$on('$stateChangeStart', function () {
            _this.handleSubscription.unsubscribe();
        });
    }
    ShippingOptionsController.prototype.$onInit = function () {
        var _this = this;
        this.Auth.getConfigUrl().then(function (config) {
            _this.troveValidateaddressService.AkrisApi = config.awsAkrisServiceUrlPattern.replace('{ServiceName}', 'shipping');
        });
        this.Auth.isLoggedIn(function (loggedInUser) {
            if (!loggedInUser) {
                _this.$window.location = '/auth/ares';
            }
        });
        this.Auth.subscribe(this.$scope, function (event, user) {
            if (user) {
                _this.loggedInUser = user;
            }
        }, true);
        this.CartService._getCart(true).then(function (response) {
            var cart = response.data.response;
            if (cart.aresLineItems.length === 0) {
                _this.$state.go('cart');
            }
            if (cart.shippingAddress && cart.shippingAddress.addressId) {
                var address = cart.shippingAddress;
                _this.isDefault = address.isDefault;
                _this.disableDefaultCheckbox = address.isDefault;
                _this.addShippingAddressToCart(address);
            }
            else {
                _this.useDefaultAddress();
            }
        });
        this.validateAddress();
    };
    ShippingOptionsController.prototype.useDefaultAddress = function () {
        var _this = this;
        this.ShippingOptionService.getDefaultAddress().then(function (response) {
            var defaultAddress = response.data.response;
            if (defaultAddress && defaultAddress.addressId) {
                _this.isDefault = true;
                _this.disableDefaultCheckbox = true;
                _this.ShippingAddressChecked = defaultAddress;
                _this.sourceValidateAddress = 2;
                _this.addShippingAddressToCart(defaultAddress);
            }
        });
    };
    ShippingOptionsController.prototype.showExistingAddresses = function (evt, templateName) {
        var _this = this;
        this.isNewAddress = false;
        this.isExistingAddress = true;
        this.displayShippingOption = false;
        this.ModalPopupService.showPopup(evt, templateName, ExistingAddressListController, { loggedInUser: this.loggedInUser }).then(function (response) {
            // Use address only when current address form is empty or null
            if (response && response.address) {
                var address_1 = response.address;
                _this.displayInfoCard = true;
                _this.isNewAddress = false;
                _this.isDefault = address_1.isDefault;
                _this.disableDefaultCheckbox = address_1.isDefault;
                _this.isShippingOptionSelected = false;
                _this.addressId = response.addressId;
                _this.addressKey = response.addressKey;
                _this.ShippingAddressChecked = address_1;
                _this.$timeout(function () {
                    _this.addShippingAddressToCart(address_1);
                });
            }
        });
    };
    ShippingOptionsController.prototype.resetShippingAddress = function () {
        this.isDefault = false;
        this.isNewAddress = true;
        this.disableDefaultCheckbox = false;
        this.displayInfoCard = false;
        this.displayShippingOption = false;
        this.isShippingOptionSelected = false;
        this.addressTypes = [{ id: 0, type: 'Business' }, { id: 1, type: 'Patient' }];
        this.$scope.$broadcast('resetNewAddressForm', {});
    };
    ShippingOptionsController.prototype.checkItemErrors = function (cart) {
        var _this = this;
        // scenario:
        // 1. CA/Non-CA restriction; 109
        // 2. RX Restriction 875 876 878 115
        // 3. Vendor Back-order/ Discontinuous with quantity exceeds warehouse storage; error 117 112 103
        // 4. Back-order with International address that exceeds warehouse storage; 113 (31)
        // 5. International address that exceeds warehouse storage; 20
        // 6. Discontinued items with quantity greater than available
        // Caution: CA restriction product with backorder status will return both error/warning code;
        var errorItems = [];
        var isInternationalAddress = cart.shippingAddress && cart.shippingAddress.countryCode !== 'US';
        this.isHeatSensitiveItemInCart = false;
        cart.aresLineItems.forEach(function (item) {
            if (isInternationalAddress &&
                _this.itemContainsErrorCode(item, [113, 20, 31]) &&
                !_this.itemContainsErrorCode(item, [109]) &&
                item.quantity > item.onHandQuantity ||
                _this.itemContainsErrorCode(item, [117, 112, 103]) && item.quantity > item.onHandQuantity) {
                errorItems.push(item);
            }
            if (item.isHeatSensitive)
                _this.isHeatSensitiveItemInCart = true;
            if (_this.itemContainsErrorCode(item, [875, 876, 878, 109, 115])) {
                item.onHandQuantity = 0;
                errorItems.push(item);
            }
            if (_this.itemContainsErrorCode(item, 118) && item.quantity > item.onHandQuantity) {
                errorItems.push(item);
            }
        });
        return errorItems;
    };
    ShippingOptionsController.prototype.itemContainsErrorCode = function (item, code) {
        // check if item error/warning contains specific error code
        if (!Array.isArray(code))
            code = [code];
        var containsErr = false;
        item.errors.forEach(function (error) {
            code.forEach(function (c) {
                if (error.code === c)
                    containsErr = true;
            });
        });
        item.warnings.forEach(function (warning) {
            code.forEach(function (c) {
                if (warning.code === c)
                    containsErr = true;
            });
        });
        return containsErr;
    };
    ShippingOptionsController.prototype.addNewShippingAddressToCart = function () {
        var address = this.newShippingAddress;
        address.saveNewAddress = true;
        address.isDefault = this.isDefault;
        address.isDropShip = (this.selectedAddressType && this.selectedAddressType.type === 'Patient') ||
            (this.loggedInUser && this.loggedInUser.accountType === 'Patient');
        if (address.countryCode === 'US') {
            this.displayAddressSpinner = true;
            this.sourceValidateAddress = 1;
            this.ShippingAddressChecked = address;
            this.troveValidateaddressService.checkaddress({
                "street1": address.line1,
                "street2": address.line2,
                "postalcode": address.postalCode,
                "city": address.city,
                "regionCode": address.regionCode,
                "countryCode": address.countryCode,
                "isDefault": address.isDefault,
                "showNextStep": address.isDropShip != true,
                "isNewAddress": true
            });
        }
        else {
            this.addShippingAddressToCart(address);
        }
    };
    ShippingOptionsController.prototype.addShippingAddressToCart = function (address, keepShippingOption) {
        var _this = this;
        this.displayAddressSpinner = true;
        this.displayShippingOption = false;
        this.isNewAddress = false;
        var addressType = address.isDropShip ? 'Patient' : 'Business';
        return this.CartService.addShippingAddress(address, addressType, keepShippingOption)
            .then(function (response) {
            var cart = response.data.response;
            _this.setAddressCard(cart.shippingAddress);
            if (!cart.aresLineItems || cart.aresLineItems.length === 0) {
                _this.$state.go('cart');
            }
            var errorItems = _this.checkItemErrors(cart);
            if (errorItems.length) {
                _this.displayErrorPopup(errorItems)
                    .then(function (res) {
                    if (res.option === 'Change Address') {
                        _this.displayInfoCard = false;
                        _this.displayAddressSpinner = false;
                        _this.displayShippingOption = false;
                    }
                    if (res.option === 'Accept Changes') {
                        var itemList_1 = [];
                        res.itemsAdjusted.forEach(function (item) {
                            itemList_1.push({
                                itemId: item.itemId,
                                quantity: item.quantity
                            });
                        });
                        _this.CartService.updateItemList(itemList_1)
                            .then(function (data) {
                            if (data.response.itemCount === 0) {
                                _this.$state.go('cart');
                            }
                            _this.addShippingAddressToCart(cart.shippingAddress);
                        });
                    }
                });
            }
            else {
                _this.theShippingAddress = cart.shippingAddress;
            }
        })
            .finally(function () {
            _this.displayAddressSpinner = false;
            _this.displayShippingOption = true;
            _this.CartService._getCart(true);
        });
    };
    ShippingOptionsController.prototype.displayErrorPopup = function (errorItems) {
        return this.$mdDialog.show({
            multiple: true,
            controller: ShippingErrorModalController,
            controllerAs: 'pop',
            locals: { params: { itemsAdjusted: errorItems, errorCode: null } },
            template: require('./shipping-error-modal/shipping-error-modal.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true
        });
    };
    ShippingOptionsController.prototype.setAddressCard = function (address) {
        if (address && !address.addressClass)
            address = new Address(address);
        this.addressInfo = {
            recipient: address.recipientName,
            address: "\n              " + address.line1 + " " + (address.line2
                ? address.line2
                : '') + "<br>\n               " + address.city + ", " + address.regionCode + " \n               " + (address.postalCode.length > 5 &&
                address.countryCode === 'US'
                ? address.postalCode.substr(0, 5) +
                    '-' + address.postalCode.substr(5)
                : address.postalCode) + ", \n               " + address.countryName.toLowerCase() + "\n            "
        };
        if (this.loggedInUser.accountType === 'Practitioner')
            this.addressInfo = Object.assign({
                type: address.addressClass === Address.addressTypes.PATIENT ? 'Patient' : 'Business'
            }, this.addressInfo);
        this.displayInfoCard = true;
    };
    ShippingOptionsController.prototype.isFormValid = function () {
        if (this.newShippingAddress) {
            return this.shiptoAddrForm.$valid;
        }
    };
    ShippingOptionsController.prototype.shippingOptionSelected = function (option) {
        var _this = this;
        this.$rootScope.loading = true;
        this.Util.handleApiResponse(this.CartService.addShippingVia(option), this, function () {
            _this.shippingMethod = option;
            _this.isShippingOptionSelected = true;
            _this.CartService.readyForPayment = true;
        }).finally(function () { return _this.$rootScope.loading = false; });
    };
    ShippingOptionsController.prototype.selectPayment = function () {
        var _this = this;
        var continuation = function () {
            var address = _this.ShippingAddressChecked;
            if (address.countryCode === 'US') {
                address.isDefault = _this.isDefault;
                _this.sourceValidateAddress = 2;
                _this.troveValidateaddressService.checkaddress({
                    "street1": address.line1,
                    "street2": address.line2,
                    "postalcode": _this.formatPostalCodeForUS(address),
                    "city": address.city,
                    "regionCode": address.regionCode,
                    "countryCode": address.countryCode,
                    "isDefault": address.isDefault,
                    "showNextStep": address.isDropShip != true,
                    "isNewAddress": address.isAddressValidationOptOut != true
                });
            }
            else {
                var address_2 = _this.theShippingAddress;
                address_2.isDefault = _this.isDefault;
                _this.addShippingAddressToCart(address_2, true).then(function () { _this.$state.go('payment'); });
            }
        };
        if (this.manualShippingCostForm && this.manualShippingCostForm.manualShippingCost.$dirty) {
            this.shippingMethod.cost = this.csaShippingCost;
            this.CartService.addShippingVia(this.shippingMethod).then(continuation);
        }
        else
            continuation();
    };
    ShippingOptionsController.prototype.validateAddress = function () {
        var _this = this;
        var addAddressToCart = function () {
            _this.addShippingAddressToCart(_this.ShippingAddressChecked, _this.sourceValidateAddress === 2).then(function () {
                if (_this.sourceValidateAddress === 2)
                    _this.$state.go('payment');
            });
        };
        this.handleSubscription = this.troveValidateaddressService.selectedAddress().subscribe(function (data) {
            if (_this.sourceValidateAddress == 1) {
                _this.displayAddressSpinner = false;
            }
            var isRenterAddress = false;
            switch (data.eventtype) {
                case 0: {
                    break;
                }
                case 1: {
                    _this.ShippingAddressChecked.isAddressValidationOptOut = data.userOptOut ? data.userOptOut : _this.ShippingAddressChecked.isAddressValidationOptOut;
                    break;
                }
                case 2: {
                    isRenterAddress = true;
                    break;
                }
                case 3: {
                    var address = data.selectedaddress;
                    _this.ShippingAddressChecked.line1 = address.street1;
                    _this.ShippingAddressChecked.line2 = address.street2;
                    _this.ShippingAddressChecked.postalCode = address.postalCode.replace('-', '');
                    _this.ShippingAddressChecked.regionCode = address.regionCode;
                    _this.ShippingAddressChecked.city = address.city;
                    _this.ShippingAddressChecked.isDefault = address.isDefault;
                    break;
                }
                case 5: {
                    isRenterAddress = true;
                    alert = _this.$mdDialog.alert({
                        title: 'Alert',
                        textContent: 'Please re-enter address.',
                        ok: 'Close'
                    });
                    _this.$mdDialog
                        .show(alert)
                        .finally(function () {
                        alert = undefined;
                    });
                    break;
                }
            }
            if (_this.sourceValidateAddress == 2 && data.eventtype == 3) {
                _this.AddressService.updateAddress(_this.ShippingAddressChecked).then(addAddressToCart);
            }
            else if (!isRenterAddress)
                addAddressToCart();
        });
    };
    ShippingOptionsController.prototype.formatPostalCodeForUS = function (address) {
        return (address.postalCode.length > 5 &&
            address.countryCode === 'US'
            ? address.postalCode.substr(0, 5) +
                '-' + address.postalCode.substr(5)
            : address.postalCode);
    };
    return ShippingOptionsController;
}());
export default ShippingOptionsController;
//# sourceMappingURL=shipping-options.controller.js.map